// extracted by mini-css-extract-plugin
export var Container = "Layout-module--Container--zZyhv";
export var TopContent = "Layout-module--TopContent--Tfomt";
export var Content = "Layout-module--Content--QbPEk";